import PlayerComputer from '../../CribbageCore/src/Game/PlayerComputer.js'

export default class TestAutomator {
    constructor(app) {
        this.app = app;
        this.app.appEvent = this.onAppEvent.bind(this);
        this.timeout = ms => new Promise(res => setTimeout(res, ms));
        this.playerComputer = null;
        this.isTesting = false;
        this.delay = 200;
        this.count = 0;
        this.option = null;
        this.gameController = null; //is not created until app is started

    }


    //local game tester that plays a game and quits and joins the next one (new instances - local)
    start(optionForce) {
        if (optionForce) this.option = optionForce;
        if (this.option) optionForce = this.option;
        this.isTesting = true;
        this.gameController = this.app.controllers["Game"];
        this.nextStep();
    }
     nextStep() {
        if (!this.isTesting) return;
        let optionForce = this.option;

        //turn off ads
        //nav to level page
        //start testing game
        //on end game, quit
        //repeat

        //destroy old computer player
        if (this.playerComputer) this.playerComputer.destroy();
        this.playerComputer = null;

        this.app.removeAds();

        //let option = Math.floor(Math.random() * 5); // returns a random integer from 0 to 3
        let option = Math.floor(Math.random() * 4); // returns a random integer from 0 to 2 //-no online
        if (optionForce) option = optionForce;

        //random level from array
        //let levels = ["Easy", "Medium", "Hard", "CrazyNinja","InsaneMonkey"];
        //let levels = ["InsaneMonkey"];
        let levels = ["Easy", "Medium", "Hard"];
        let level = levels[Math.floor(Math.random() * levels.length)];

     
        if (option === 0) {
            this.app.navigate("MainMenu");
            this.timeout(this.delay)
                .then(function () {
                    this.app.navigate("LevelMenu");
                    return this.timeout(this.delay);
                }.bind(this))
                .then(async function () {
                    this.app.navigate("Game");
                    await this.gameController.startNewGame(level);
                    this.gameController.cribbage.flowControl.delayGame = 100;
                    this.gameController.cribbage.player1.delay = 100;
                    this.gameController.cribbage.player2.delay = 100;
                }.bind(this));

        }
        if (option === 1) {
            this.app.navigate('Achievements');
            this.timeout(this.delay)
                .then(function () {
                    this.app.navigate('Statistics');
                    return this.timeout(this.delay);
                }.bind(this))
                .then(function () {
                    this.nextStep();
                }.bind(this));
        }
        if (option === 2) {
            this.app.navigate("MainMenu");
            this.timeout(this.delay)
                .then(function () {
                    this.app.navigate('HowToPlay');
                    return this.timeout(this.delay);
                }.bind(this))
                .then(function () {
                    this.app.navigate('Contact');
                    return this.timeout(this.delay);
                }.bind(this)).then(function () {
                    this.app.navigate("MainMenu");
                    return this.timeout(this.delay);
                }.bind(this))
                .then(function () {
                    this.nextStep();
                }.bind(this));
        }
        if (option === 3) {
            this.app.navigate("Store");
            this.timeout(this.delay)
                .then(function () {
                    this.app.navigate('IAPMenu');
                    return this.timeout(this.delay);
                }.bind(this))
                .then(function () {
                    this.nextStep();
                }.bind(this));
        }
        if (option === 4) {
            this.timeout(1)
                .then(function () {
                    this.app.navigate('FindServer');
                    return this.timeout(2000);
                }.bind(this))
                .then(function () {
                    this.app.joinRoom("testRoom", this.app.userdata);
                    //this.app.joinRoom("", this.app.userdata);
                    return this.timeout(10000);
                }.bind(this))
                .then(function () {
                    if (!this.gameController.cribbage) this.nextStep(); //can't join
                    if (this.gameController.cribbage) {
                        let state = this.gameController.cribbage.currentState;
                        if (state === "preGame") {
                            this.nextStep();
                        }
                    }
                }.bind(this));
        }
        if (option === "onlineForver") {
            this.timeout(1)
                .then(function () {
                    this.app.navigate('FindServer');
                    return this.timeout(2000);
                }.bind(this))
                .then(function () {
                    //this.app.joinRoom("testRoom", this.app.userdata);
                    this.app.joinRoom("", this.app.userdata);
                    return this.timeout(15000);
                }.bind(this))
                .then(function () {
                    if (!this.gameController.cribbage) this.nextStep(); //can't join
                    let state = this.gameController.cribbage.currentState;
                    if (state === "preGame") {
                        this.nextStep();
                    }
                }.bind(this));
        }

    }
    onAppEvent(event) {
        let option = this.option;
        if (!this.isTesting) return;
        if (option === "onlineForver") {
            
            if (event === "gameStarted") {
                this.playerComputer = new PlayerComputer(this.gameController.cribbage, this.gameController.tablePosition, 300, "test", "InsaneMonkey", "InsaneMonkey");
                this.playerComputer.randomChat = false;
                this.playerComputer.welcomeChat = true;
            }
            return;
        }
        if (event === "endMatch") {
            this.count = this.count + 1;
            // if(this.count > 9){
            //     location.reload();
            // }
            this.timeout(this.delay)
                .then(function () {
                    this.gameController.quitGame();
                    return this.timeout(this.delay);
                }.bind(this))
                .then(function () {
                    this.nextStep();
                }.bind(this))
        }
        if (event === "gameStarted") {
            this.gameController.cribbage.debugUI = true;
            //this.app.cribbage.event.addListener("stateChange", this.onStateChanged.bind(this));

            if (this.gameController.cribbage.level == "Online") {
                this.playerComputer = new PlayerComputer(this.gameController.cribbage, this.gameController.tablePosition, 2000, "test", "Hard", "Hard");
                this.playerComputer.randomChat = false;
                this.playerComputer.welcomeChat = true;
            } else {
                this.playerComputer = new PlayerComputer(this.gameController.cribbage, this.gameController.tablePosition, 300, "test", "Hard", "Hard");
                this.playerComputer.randomChat = false;
                this.playerComputer.welcomeChat = true;
            }

        }
        if (event === "joinGameNetwork") {
        }
    }
    // onStateChanged(state) {
    //     if (state === "endMatch") {
    //         this.timeout(2000)
    //             .then(function () {
    //                 this.app.quitGame();
    //                 return this.timeout(2000);
    //             }.bind(this))
    //             .then(function () {
    //                 this.nextStep();
    //             }.bind(this))
    //     }
    // }
    // onlineTestStart() {
    //     //wire up event handlers
    //     this.socketClient.onJoin = this.onlineTestOnJoin.bind(this);
    //     this.socketClient.onLeave = this.onlineTestOnLeave.bind(this);

    //     let user = {
    //         id: Math.floor(Math.random() * 10000),
    //         name: "PlayerT" + Math.floor(Math.random() * 10000),
    //         avatar: null
    //     }
    //     user = this.userdata;

    //     //findServer()

    //     //connect and join a random room
    //     if (this.socketClient.isConncted())
    //         this.socketClient.join();
    //     else {
    //         this.socketClient.connectAsync(user)
    //             .then(function (value) {
    //                 this.socketClient.join();
    //             }.bind(this))
    //             .catch(function (err) {
    //                 console.error("websocket: failed to connect", err);
    //             });
    //     }

    // }
    // onlineTestOnJoin(tablePosition) {

    //     if (this.cribbage) this.cribbage.destroy();
    //     this.cribbage = null;
    //     this.cribbage = new CribbageProxy(this.socketClient);
    //     this.cribbage.debug = this.debug;
    //     this.cribbage.level = "Online";
    //     this.cribbage.event.addListener("stateChange", this.onStateChanged.bind(this));

    //     this.tablePosition = tablePosition;
    //     let player = new PlayerComputer(this.cribbage, tablePosition, 1000, "test", "CrazyNinja", "NinjaTest");
    //     this.cribbage.users.push(player);


    //     this.changePage("Game/Online");
    //     //enter ui as my user name so it know what view to give me
    //     this.game.scene.start("Game", true, false, this.cribbage, tablePosition, "online");
    // }
    // onlineTestOnLeave() {
    //     //this.socketClient.joinRoom();
    // }
    // onlineTestDisconnect() {

    // }

    onPageChanged(page) {

    }
    stop() {
        this.isTesting = false;
    }
    //todo: local game tester that plays a game at high speed and never quits   (one long instances - local)
    //todo: online game tester that plays a game and quits and joins the next one  (new instances - online)
}